/* eslint-disable jsx-a11y/label-has-associated-control */
import { Button, Dialog, IconButton, TextField } from '@material-ui/core';
import { CopyIcon, XIcon } from '@phosphor-icons/react';
import { FC, useEffect, useState } from 'react';
import { GENERATED_PASSWORD_TEXT, GENERATED_PASSWORD_TITLE } from '../constants';
import { useStyles } from '../styles';

interface GeneratedPasswordModalProps {
  open: boolean;
  password: string;
  onClose: () => void;
  title?: string;
  text?: string;
}

const GeneratedPasswordModal: FC<GeneratedPasswordModalProps> = ({
  open,
  password,
  onClose,
  title = GENERATED_PASSWORD_TITLE,
  text = GENERATED_PASSWORD_TEXT,
}) => {
  const classes = useStyles();
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!open) {
      setCopied(false);
    }
  }, [open]);

  const copyPassword = async () => {
    try {
      await navigator.clipboard.writeText(password);
      setCopied(true);
    } catch {
      const input = document.createElement('textarea');
      input.value = password;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      setCopied(true);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      className={classes.passwordDialog}
      aria-labelledby="generated-password-title">
      <div className={classes.passwordDialogHeader}>
        <h2 id="generated-password-title" className={classes.passwordDialogTitle}>
          {title}
        </h2>
        <IconButton
          aria-label="Fermer"
          className={classes.passwordDialogClose}
          onClick={onClose}>
          <XIcon size={20} />
        </IconButton>
      </div>

      <p className={classes.passwordDialogText}>{text}</p>

      <label className={classes.passwordFieldLabel} htmlFor="generated-password">
        Mot de passe généré
      </label>
      <div className={classes.passwordRow}>
        <TextField
          id="generated-password"
          className={classes.passwordInput}
          variant="outlined"
          value={password}
          InputProps={{ readOnly: true }}
        />
        <Button
          className={classes.copyPasswordBtn}
          startIcon={<CopyIcon size={18} />}
          onClick={copyPassword}>
          {copied ? 'Copié' : 'Copier le mot de passe'}
        </Button>
      </div>

      <Button className={classes.closePasswordBtn} onClick={onClose}>
        Fermer
      </Button>
    </Dialog>
  );
};

export default GeneratedPasswordModal;
